import React from 'react';
import { connect } from 'react-redux';

const mapState = (state) => {
    return {
        familiar : state.af.familiar,
        paso: state.af.pasoInvitado,
    };
}

const mapDispatch = (dispatch) => {
    return {
		pasoInvitado: (paso) => {
			dispatch({ "type": "AF_EDITAR_PASO_INVITADO", "pasoInvitado": paso });
		}
    }
}

class InvitadoEliminado extends React.Component {

  constructor(props) {
    super(props);
  }

	close = () => {
    $(".modal-guest").hide();
		this.props.pasoInvitado(0);
	}

    render() {
      return (
        <div className="modal-guest">
          <div style={{"marginRight": "10px"}}>
            <img src={ require("../img/check_green.svg") }/>
          </div>
          <div>
            <div className="delete-guest">Invitado eliminado</div>
            <div className="text-guest">
              El invitado se ha eliminado con éxito
            </div>
          </div>
          <div style={{"display":"flex"}, {"justifyContent":"center"}}>
            <i><img onClick={this.close.bind(this)} src={require("../img/close_green.svg")} /></i>
          </div>
        </div>
      );
	}
}

export default connect(mapState, mapDispatch)(InvitadoEliminado);



// WEBPACK FOOTER //
// ./src/acceso-familiar/InvitadoEliminadoMovil.cmpt.js